export const getCurrentDemoAPIKey = (): string => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get('apiKey') || process.env.DEMO_API_KEY as string;
};
